export default __webpack_public_path__ + "static/media/shapes.5b30a9bf.svg";